
export default{
    name: "BlockHeading",
    props:{
        title: String,
        subtitle: String,
    },
}
